/**
 * CORE-1108 — stand-in for `@sentry-internal/replay` in the WEB bundle.
 *
 * Session Replay has been off everywhere since 20.08.2026 (the owner paused it
 * over Sentry quota — see src/config/sentryReplay.ts, PAUSED_FOR_QUOTA), yet
 * 123.6 KB of it shipped in the entry chunk on every load. Nothing of ours
 * imports it: `@sentry/browser`'s barrel re-exports it, and metro does no
 * tree-shaking for web, so the whole recorder rode along behind an export
 * nobody read.
 *
 * metro.config.js swaps this file in ONLY while replay is paused, and it reads
 * that flag out of sentryReplay.ts rather than keeping a second copy — flip
 * PAUSED_FOR_QUOTA back to false and the real package returns with it.
 *
 * The two exports keep their names so the re-export chain in @sentry/browser
 * still resolves. Calling one is a mistake worth hearing about rather than a
 * silent no-op: it would mean replay was switched on somewhere the bundler was
 * told it is off.
 */
const paused = () => {
  throw new Error(
    'Sentry Session Replay is excluded from this web bundle (CORE-1108) because ' +
      'PAUSED_FOR_QUOTA is true in src/config/sentryReplay.ts. Set it to false to ' +
      'ship the real @sentry-internal/replay again.',
  );
};

export function replayIntegration() {
  return paused();
}

export function getReplay() {
  return paused();
}
